"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var styles = tslib_1.__importStar(require("./ProgressBar.style"));

function ProgressBar(_ref) {
  var total = _ref.total,
      value = _ref.value,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'GRAY' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100%' : _ref$width,
      className = _ref.className;
  return jsx_runtime_1.jsx("div", Object.assign({
    css: styles.wrapper(width),
    className: className
  }, {
    children: jsx_runtime_1.jsx("div", {
      className: "mrt-progressbar-value",
      css: styles.bar(value / total * 100, color)
    }, void 0)
  }), void 0);
}

exports.default = react_1.memo(ProgressBar);